// pages/AgendaPage.js o donde desees usarlo
import React from 'react';
import { Box } from '@mui/material';
import OrdenesServicios from '../../components/administration/serviceOrders/ServiceOrdersDashboard';

const OrdenesServiciosPage = () => {
    return (
        <Box sx={{ p: 2 }}>
            <OrdenesServicios
                onReorder={(newOrder) => {
                    console.log('Nuevo orden de ordenes de servicio:', newOrder);
                }}
            />
        </Box>
    );
};

export default OrdenesServiciosPage;
